import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'orderByTranslate'
})
export class OrderByTranslatePipe implements PipeTransform {

  public constructor(private service: TranslateService) {
  }

  transform(array, orderBy, ascending = true) {
    if (!orderBy || orderBy.trim() === "") {
      return Array.from(array).sort((item1: any, item2: any) => {
        if (ascending) {
          return this.orderByComparator(item1, item2);
        }
        return this.orderByComparator(item2, item1);
      });
    }
    if (ascending) {
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.orderByComparator(item1[orderBy], item2[orderBy]);
      });
    } else {
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.orderByComparator(item2[orderBy], item1[orderBy]);
      });
    }
  }

  orderByComparator(a: any, b: any): number {
    if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
      if (this.service.instant(a) < this.service.instant(b)) {
        return -1;
      }
      if (this.service.instant(a) > this.service.instant(b)) {
        return 1;
      }
    } else {
      if (parseFloat(a) < parseFloat(b)) {
        return -1;
      }
      if (parseFloat(a) > parseFloat(b)) {
        return 1;
      }
    }
    return 0;
  }
}
